import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=2c501e3f&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c501e3f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c501e3f')) {
      api.createRecord('2c501e3f', component.options)
    } else {
      api.reload('2c501e3f', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=2c501e3f&scoped=true&", function () {
      api.rerender('2c501e3f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27LnDkt6wb5zl/JS/comp/Accordion.vue"
export default component.exports